// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file mobility_search/v1/search_detail.proto (package mobility_search.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration } from "@bufbuild/protobuf/wkt";
import type { CO2Emission, Fare, Flags, Price, TrainSegment, TransportAgency } from "../../mobility/v1/common_pb";
import { file_mobility_v1_common } from "../../mobility/v1/common_pb";
import type { VehicleCategory, VehicleProperties, VehicleTransmission } from "../../mobility/v1/vehicle_pb";
import { file_mobility_v1_vehicle } from "../../mobility/v1/vehicle_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mobility_search/v1/search_detail.proto.
 */
export const file_mobility_search_v1_search_detail: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_duration, file_mobility_v1_common, file_mobility_v1_vehicle]);

/**
 * TrainMobilitySolutionDetail - cabin classes and offers for a train solution.
 *
 * @generated from message mobility_search.v1.TrainMobilitySolutionDetail
 */
export type TrainMobilitySolutionDetail = Message<"mobility_search.v1.TrainMobilitySolutionDetail"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated mobility.v1.TrainSegment segments = 2;
   */
  segments: TrainSegment[];

  /**
   * @generated from field: mobility.v1.Price price = 3;
   */
  price?: Price;

  /**
   * @generated from field: mobility.v1.Flags flags = 4;
   */
  flags?: Flags;

  /**
   * @generated from field: mobility.v1.CO2Emission co2_emission = 5;
   */
  co2Emission?: CO2Emission;

  /**
   * @generated from field: repeated mobility_search.v1.CabinClass cabin_classes = 6;
   */
  cabinClasses: CabinClass[];

  /**
   * @generated from field: optional mobility_search.v1.LoadMoreTrainSolutionsAction load_more_action = 7;
   */
  loadMoreAction?: LoadMoreTrainSolutionsAction;
};

/**
 * Describes the message mobility_search.v1.TrainMobilitySolutionDetail.
 * Use `create(TrainMobilitySolutionDetailSchema)` to create a new message.
 */
export const TrainMobilitySolutionDetailSchema: GenMessage<TrainMobilitySolutionDetail> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 0);

/**
 * LoadMoreTrainSolutionsAction - cursor for paginating train results within a search run.
 *
 * @generated from message mobility_search.v1.LoadMoreTrainSolutionsAction
 */
export type LoadMoreTrainSolutionsAction = Message<"mobility_search.v1.LoadMoreTrainSolutionsAction"> & {
  /**
   * @generated from field: string search_id = 1;
   */
  searchId: string;

  /**
   * @generated from field: string last_mobility_solution_id = 2;
   */
  lastMobilitySolutionId: string;

  /**
   * @generated from field: optional mobility_search.v1.TrainConnectionsFilter connections_filter = 3;
   */
  connectionsFilter?: TrainConnectionsFilter;

  /**
   * @generated from field: optional mobility_search.v1.TrainListSort sort = 4;
   */
  sort?: TrainListSort;
};

/**
 * Describes the message mobility_search.v1.LoadMoreTrainSolutionsAction.
 * Use `create(LoadMoreTrainSolutionsActionSchema)` to create a new message.
 */
export const LoadMoreTrainSolutionsActionSchema: GenMessage<LoadMoreTrainSolutionsAction> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 1);

/**
 * RentalVehicleMobilitySolutionDetail - agency details and rental vehicle offers.
 *
 * @generated from message mobility_search.v1.RentalVehicleMobilitySolutionDetail
 */
export type RentalVehicleMobilitySolutionDetail = Message<"mobility_search.v1.RentalVehicleMobilitySolutionDetail"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: mobility.v1.TransportAgency agency = 2;
   */
  agency?: TransportAgency;

  /**
   * @generated from field: mobility.v1.TransportAgency return_agency = 3;
   */
  returnAgency?: TransportAgency;

  /**
   * @generated from field: mobility.v1.Flags flags = 4;
   */
  flags?: Flags;

  /**
   * @generated from field: mobility.v1.Price min_price = 5;
   */
  minPrice?: Price;

  /**
   * @generated from field: repeated mobility_search.v1.RentalVehicleOffer vehicles = 6;
   */
  vehicles: RentalVehicleOffer[];

  /**
   * @generated from field: string image_url = 7;
   */
  imageUrl: string;

  /**
   * @generated from field: mobility.v1.CO2Emission co2_emission = 8;
   */
  co2Emission?: CO2Emission;

  /**
   * @generated from field: mobility_search.v1.LoadMoreRentalVehicleSolutionsAction load_more_action = 9;
   */
  loadMoreAction?: LoadMoreRentalVehicleSolutionsAction;

  /**
   * Markdown
   *
   * @generated from field: string booking_conditions = 10;
   */
  bookingConditions: string;

  /**
   * rental_days is the number of days between pickup and return, computed
   * from the solution's schedule. Same for every vehicle in this detail
   * (one pickup/return schedule per agency/search), so it lives here rather
   * than being repeated on each RentalVehicleOffer.
   *
   * @generated from field: int32 rental_days = 11;
   */
  rentalDays: number;
};

/**
 * Describes the message mobility_search.v1.RentalVehicleMobilitySolutionDetail.
 * Use `create(RentalVehicleMobilitySolutionDetailSchema)` to create a new message.
 */
export const RentalVehicleMobilitySolutionDetailSchema: GenMessage<RentalVehicleMobilitySolutionDetail> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 2);

/**
 * RentalVehicle - a rental vehicle offer.
 *
 * @generated from message mobility_search.v1.RentalVehicleOffer
 */
export type RentalVehicleOffer = Message<"mobility_search.v1.RentalVehicleOffer"> & {
  /**
   * @generated from field: string category = 1;
   */
  category: string;

  /**
   * @generated from field: string logo = 2;
   */
  logo: string;

  /**
   * @generated from field: mobility.v1.VehicleProperties properties = 3;
   */
  properties?: VehicleProperties;

  /**
   * @generated from field: mobility.v1.Price price = 4;
   */
  price?: Price;

  /**
   * @generated from field: string equivalent_model = 5;
   */
  equivalentModel: string;

  /**
   * category_class is the agency's rate card category letter (e.g. "F" for a
   * SIXT SDMR), falling back to the ACRISS category letter when the agency
   * has no rate card entry for the vehicle -- distinct from mobility.v1.VehicleCategory, which is an unrelated
   * classification (used for describing an immobilized vehicle in an
   * incident case) and does not map onto ACRISS letters.
   *
   * @generated from field: string category_class = 6;
   */
  categoryClass: string;

  /**
   * acriss is the full 4-letter ACRISS code of the offer (e.g. "CDAD").
   *
   * @generated from field: string acriss = 7;
   */
  acriss: string;

  /**
   * one_way_fee is the drop-off fee for returning the vehicle to another agency, already
   * included in price. Unset on a rental returned to its pickup agency.
   *
   * @generated from field: optional mobility.v1.Price one_way_fee = 8;
   */
  oneWayFee?: Price;
};

/**
 * Describes the message mobility_search.v1.RentalVehicleOffer.
 * Use `create(RentalVehicleOfferSchema)` to create a new message.
 */
export const RentalVehicleOfferSchema: GenMessage<RentalVehicleOffer> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 3);

/**
 * LoadMoreRentalVehicleSolutionsAction - cursor for paginating rental vehicle results within a search run.
 *
 * @generated from message mobility_search.v1.LoadMoreRentalVehicleSolutionsAction
 */
export type LoadMoreRentalVehicleSolutionsAction = Message<"mobility_search.v1.LoadMoreRentalVehicleSolutionsAction"> & {
  /**
   * @generated from field: string search_id = 1;
   */
  searchId: string;

  /**
   * @generated from field: string last_mobility_solution_id = 2;
   */
  lastMobilitySolutionId: string;

  /**
   * @generated from field: optional mobility_search.v1.RentalVehicleListSort sort = 3;
   */
  sort?: RentalVehicleListSort;

  /**
   * @generated from field: optional mobility.v1.Price max_price = 4;
   */
  maxPrice?: Price;

  /**
   * @generated from field: optional mobility.v1.VehicleTransmission transmission_filter = 5;
   */
  transmissionFilter?: VehicleTransmission;

  /**
   * @generated from field: optional mobility.v1.VehicleCategory category_filter = 6;
   */
  categoryFilter?: VehicleCategory;
};

/**
 * Describes the message mobility_search.v1.LoadMoreRentalVehicleSolutionsAction.
 * Use `create(LoadMoreRentalVehicleSolutionsActionSchema)` to create a new message.
 */
export const LoadMoreRentalVehicleSolutionsActionSchema: GenMessage<LoadMoreRentalVehicleSolutionsAction> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 4);

/**
 * TaxiMobilitySolutionDetail - agency, pricing and conditions for a taxi solution, including possible trailer towage.
 *
 * @generated from message mobility_search.v1.TaxiMobilitySolutionDetail
 */
export type TaxiMobilitySolutionDetail = Message<"mobility_search.v1.TaxiMobilitySolutionDetail"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: mobility.v1.TransportAgency agency = 2;
   */
  agency?: TransportAgency;

  /**
   * @generated from field: mobility.v1.Flags flags = 3;
   */
  flags?: Flags;

  /**
   * @generated from field: mobility.v1.Price estimated_price = 4;
   */
  estimatedPrice?: Price;

  /**
   * @generated from field: google.protobuf.Duration estimated_arrival_in_minutes = 5;
   */
  estimatedArrivalInMinutes?: Duration;

  /**
   * @generated from field: int32 max_passenger_capacity = 6;
   */
  maxPassengerCapacity: number;

  /**
   * @generated from field: string label = 7;
   */
  label: string;

  /**
   * @generated from field: mobility.v1.CO2Emission co2_emission = 8;
   */
  co2Emission?: CO2Emission;

  /**
   * Price and ride duration bounds between light and heavy traffic at departure; unset when no
   * traffic estimate is available.
   *
   * @generated from field: optional mobility.v1.Price min_price = 9;
   */
  minPrice?: Price;

  /**
   * @generated from field: optional mobility.v1.Price max_price = 10;
   */
  maxPrice?: Price;

  /**
   * @generated from field: optional google.protobuf.Duration min_ride_duration = 11;
   */
  minRideDuration?: Duration;

  /**
   * @generated from field: optional google.protobuf.Duration max_ride_duration = 12;
   */
  maxRideDuration?: Duration;

  /**
   * Whether the taxi leaves soon enough for today's traffic to say something about its ride, so
   * live traffic is worth showing next to it.
   *
   * @generated from field: bool live_traffic = 13;
   */
  liveTraffic: boolean;

  /**
   * Ways to drive the ride, Google's preferred first; empty when no route could be computed.
   *
   * @generated from field: repeated mobility_search.v1.TaxiRoute routes = 14;
   */
  routes: TaxiRoute[];

  /**
   * Taxi drivers free near the pickup right now, closest first and at most 10; empty unless
   * live_traffic is set.
   *
   * @generated from field: repeated mobility_search.v1.AvailableTaxiDriver available_drivers = 15;
   */
  availableDrivers: AvailableTaxiDriver[];
};

/**
 * Describes the message mobility_search.v1.TaxiMobilitySolutionDetail.
 * Use `create(TaxiMobilitySolutionDetailSchema)` to create a new message.
 */
export const TaxiMobilitySolutionDetailSchema: GenMessage<TaxiMobilitySolutionDetail> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 5);

/**
 * A taxi driver free to take a ride, located but not identified.
 *
 * @generated from message mobility_search.v1.AvailableTaxiDriver
 */
export type AvailableTaxiDriver = Message<"mobility_search.v1.AvailableTaxiDriver"> & {
  /**
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 2;
   */
  longitude: number;
};

/**
 * Describes the message mobility_search.v1.AvailableTaxiDriver.
 * Use `create(AvailableTaxiDriverSchema)` to create a new message.
 */
export const AvailableTaxiDriverSchema: GenMessage<AvailableTaxiDriver> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 6);

/**
 * One way to drive a taxi ride.
 *
 * @generated from message mobility_search.v1.TaxiRoute
 */
export type TaxiRoute = Message<"mobility_search.v1.TaxiRoute"> & {
  /**
   * Path in Google's encoded polyline format.
   *
   * @generated from field: string polyline = 1;
   */
  polyline: string;

  /**
   * @generated from field: int32 distance_meters = 2;
   */
  distanceMeters: number;

  /**
   * Ride duration between light and heavy traffic at departure; unset when Google gave no route
   * of this length under that traffic.
   *
   * @generated from field: optional google.protobuf.Duration min_duration = 3;
   */
  minDuration?: Duration;

  /**
   * @generated from field: optional google.protobuf.Duration max_duration = 4;
   */
  maxDuration?: Duration;

  /**
   * Live traffic along the route; empty unless live_traffic is set.
   *
   * @generated from field: repeated mobility_search.v1.TrafficStretch traffic = 5;
   */
  traffic: TrafficStretch[];

  /**
   * The route's own duration under the traffic it is drawn for, set even when Google gave no
   * route of this length in light or heavy traffic.
   *
   * @generated from field: google.protobuf.Duration duration = 6;
   */
  duration?: Duration;
};

/**
 * Describes the message mobility_search.v1.TaxiRoute.
 * Use `create(TaxiRouteSchema)` to create a new message.
 */
export const TaxiRouteSchema: GenMessage<TaxiRoute> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 7);

/**
 * Traffic between two points of a route's polyline, given by index.
 *
 * @generated from message mobility_search.v1.TrafficStretch
 */
export type TrafficStretch = Message<"mobility_search.v1.TrafficStretch"> & {
  /**
   * @generated from field: int32 start_index = 1;
   */
  startIndex: number;

  /**
   * @generated from field: int32 end_index = 2;
   */
  endIndex: number;

  /**
   * @generated from field: mobility_search.v1.TrafficSpeed speed = 3;
   */
  speed: TrafficSpeed;
};

/**
 * Describes the message mobility_search.v1.TrafficStretch.
 * Use `create(TrafficStretchSchema)` to create a new message.
 */
export const TrafficStretchSchema: GenMessage<TrafficStretch> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 8);

/**
 * CabinClass - a train cabin class grouping multiple fare offers.
 *
 * @generated from message mobility_search.v1.CabinClass
 */
export type CabinClass = Message<"mobility_search.v1.CabinClass"> & {
  /**
   * @generated from field: string cabin_class_id = 1;
   */
  cabinClassId: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: mobility.v1.Price display_price = 3;
   */
  displayPrice?: Price;

  /**
   * @generated from field: repeated mobility_search.v1.TrainOffer offers = 4;
   */
  offers: TrainOffer[];
};

/**
 * Describes the message mobility_search.v1.CabinClass.
 * Use `create(CabinClassSchema)` to create a new message.
 */
export const CabinClassSchema: GenMessage<CabinClass> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 9);

/**
 * TrainOffer - a bookable fare within a cabin class.
 *
 * @generated from message mobility_search.v1.TrainOffer
 */
export type TrainOffer = Message<"mobility_search.v1.TrainOffer"> & {
  /**
   * @generated from field: string offer_id = 1;
   */
  offerId: string;

  /**
   * @generated from field: string cabin_class_id = 2;
   */
  cabinClassId: string;

  /**
   * @generated from field: mobility.v1.Price total_price = 3;
   */
  totalPrice?: Price;

  /**
   * @generated from field: repeated mobility.v1.Fare fares = 4;
   */
  fares: Fare[];

  /**
   * @generated from field: mobility_search.v1.Flexibility flexibility = 5;
   */
  flexibility?: Flexibility;
};

/**
 * Describes the message mobility_search.v1.TrainOffer.
 * Use `create(TrainOfferSchema)` to create a new message.
 */
export const TrainOfferSchema: GenMessage<TrainOffer> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 10);

/**
 * Flexibility - exchange and refund conditions of a train fare.
 *
 * @generated from message mobility_search.v1.Flexibility
 */
export type Flexibility = Message<"mobility_search.v1.Flexibility"> & {
  /**
   * @generated from field: mobility_search.v1.FlexibilityType type = 1;
   */
  type: FlexibilityType;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message mobility_search.v1.Flexibility.
 * Use `create(FlexibilitySchema)` to create a new message.
 */
export const FlexibilitySchema: GenMessage<Flexibility> = /*@__PURE__*/
  messageDesc(file_mobility_search_v1_search_detail, 11);

/**
 * TrainConnectionsFilter - filter for direct vs. connecting train journeys.
 *
 * @generated from enum mobility_search.v1.TrainConnectionsFilter
 */
export enum TrainConnectionsFilter {
  /**
   * @generated from enum value: TRAIN_CONNECTIONS_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRAIN_CONNECTIONS_FILTER_DIRECT_ONLY = 1;
   */
  DIRECT_ONLY = 1,

  /**
   * @generated from enum value: TRAIN_CONNECTIONS_FILTER_WITH_CONNECTIONS = 2;
   */
  WITH_CONNECTIONS = 2,
}

/**
 * Describes the enum mobility_search.v1.TrainConnectionsFilter.
 */
export const TrainConnectionsFilterSchema: GenEnum<TrainConnectionsFilter> = /*@__PURE__*/
  enumDesc(file_mobility_search_v1_search_detail, 0);

/**
 * TrainListSort - sort order for the train solutions list.
 *
 * @generated from enum mobility_search.v1.TrainListSort
 */
export enum TrainListSort {
  /**
   * @generated from enum value: TRAIN_LIST_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRAIN_LIST_SORT_DEPARTURE_TIME = 1;
   */
  DEPARTURE_TIME = 1,

  /**
   * @generated from enum value: TRAIN_LIST_SORT_PRICE = 2;
   */
  PRICE = 2,

  /**
   * @generated from enum value: TRAIN_LIST_SORT_TRAVEL_DURATION = 3;
   */
  TRAVEL_DURATION = 3,

  /**
   * @generated from enum value: TRAIN_LIST_SORT_LEAST_CO2_EMISSION = 4;
   */
  LEAST_CO2_EMISSION = 4,
}

/**
 * Describes the enum mobility_search.v1.TrainListSort.
 */
export const TrainListSortSchema: GenEnum<TrainListSort> = /*@__PURE__*/
  enumDesc(file_mobility_search_v1_search_detail, 1);

/**
 * RentalVehicleListSort - sort order for the rental vehicle solutions list.
 *
 * @generated from enum mobility_search.v1.RentalVehicleListSort
 */
export enum RentalVehicleListSort {
  /**
   * @generated from enum value: RENTAL_VEHICLE_LIST_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RENTAL_VEHICLE_LIST_SORT_PRICE = 1;
   */
  PRICE = 1,

  /**
   * @generated from enum value: RENTAL_VEHICLE_LIST_SORT_DISTANCE_FROM_ORIGIN = 2;
   */
  DISTANCE_FROM_ORIGIN = 2,
}

/**
 * Describes the enum mobility_search.v1.RentalVehicleListSort.
 */
export const RentalVehicleListSortSchema: GenEnum<RentalVehicleListSort> = /*@__PURE__*/
  enumDesc(file_mobility_search_v1_search_detail, 2);

/**
 * How freely traffic flows on a stretch of road.
 *
 * @generated from enum mobility_search.v1.TrafficSpeed
 */
export enum TrafficSpeed {
  /**
   * @generated from enum value: TRAFFIC_SPEED_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRAFFIC_SPEED_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * @generated from enum value: TRAFFIC_SPEED_SLOW = 2;
   */
  SLOW = 2,

  /**
   * @generated from enum value: TRAFFIC_SPEED_JAM = 3;
   */
  JAM = 3,
}

/**
 * Describes the enum mobility_search.v1.TrafficSpeed.
 */
export const TrafficSpeedSchema: GenEnum<TrafficSpeed> = /*@__PURE__*/
  enumDesc(file_mobility_search_v1_search_detail, 3);

/**
 * FlexibilityType - enum for the type of fare flexibility (e.g. no-flex, semi-flex, full-flex).
 *
 * @generated from enum mobility_search.v1.FlexibilityType
 */
export enum FlexibilityType {
  /**
   * @generated from enum value: FLEXIBILITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FLEXIBILITY_TYPE_NOFLEX = 1;
   */
  NOFLEX = 1,

  /**
   * @generated from enum value: FLEXIBILITY_TYPE_SEMIFLEX = 2;
   */
  SEMIFLEX = 2,

  /**
   * @generated from enum value: FLEXIBILITY_TYPE_FULLFLEX = 3;
   */
  FULLFLEX = 3,
}

/**
 * Describes the enum mobility_search.v1.FlexibilityType.
 */
export const FlexibilityTypeSchema: GenEnum<FlexibilityType> = /*@__PURE__*/
  enumDesc(file_mobility_search_v1_search_detail, 4);

